// console.log('resources/assets/js/api/fixed.js');
/*
    Imports the Cockpit API URL from the config.
*/
import { API_CONFIG } from '../config.js';

export default {
	/* GET /api/v1/fixed_tables */
	getFixedTables: function () {
		return axios.get(API_CONFIG.API_URL + '/fixed_tables');
	}
};
